export const getSolutionUrl = (base: string): string => {
	if (!base.match(/^(https)/i)) {
		base = `https://${base}`;
	}
	return `${base}/apps/uniquename/msnfp_FundraisingandEngagement`;
};
